import React from "react";
import "./CommonPopup.css";

const CommonPopup = ({
  visible,
  message,
  onConfirm,
  onClose,
  confirmText = "확인",
  cancelText = "취소"
}) => {
  if (!visible) return null;

  const stopAllEvents = (e) => {
    e.stopPropagation();
    if (e.nativeEvent?.stopImmediatePropagation) {
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  return (
    <div className="common-popup-overlay" onClick={stopAllEvents}>
      <div className="common-popup-window" onClick={stopAllEvents}>
        <div className="popup-message" dangerouslySetInnerHTML={{ __html: message }} />
        <div className="popup-buttons">
          {cancelText && (
            <button
              className="popup-btn cancel"
              onClick={(e) => {
                stopAllEvents(e);
                onClose();
              }}
            >
              {cancelText}
            </button>
          )}
          <button
            className="popup-btn confirm"
            onClick={(e) => {
              stopAllEvents(e);
              onConfirm();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommonPopup;
